import { StyleSheet, Text, type StyleProp, type TextStyle } from 'react-native';

import { colors } from '@/constants/theme';
import { parseHighlightMarkup } from '@/lib/highlightMarkup';
import { fitLineHeight } from '@/lib/textFit';

interface HighlightedTextProps {
  /** Copy with optional `**x**` markers (see lib/highlightMarkup). */
  children: string;
  style?: StyleProp<TextStyle>;
  /** Style for the marked runs. Defaults to accent-green text. */
  highlightStyle?: StyleProp<TextStyle>;
  accessibilityRole?: 'header' | 'text';
}

/**
 * Renders server copy with `**x**` phrases in the accent green. One
 * <Text> with nested spans, so wrapping / line-height behave like a
 * single paragraph on web and native.
 */
export function HighlightedText({
  children,
  style,
  highlightStyle,
  accessibilityRole,
}: HighlightedTextProps) {
  const runs = parseHighlightMarkup(children);
  return (
    <Text style={fitLineHeight(style)} accessibilityRole={accessibilityRole}>
      {runs.map((run, i) =>
        run.highlighted ? (
          <Text key={i} style={[styles.highlight, highlightStyle]}>
            {run.text}
          </Text>
        ) : (
          run.text
        ),
      )}
    </Text>
  );
}

const styles = StyleSheet.create({
  highlight: { color: colors.accentText },
});
